import Datatable from "./datatable_controller";

// Connects to data-controller="recurrence-datatable"
export default class extends Datatable {
  static targets = ['statusFilter']

  connect() {
    this.initialStartEndDate()
    super.connect()
  }

  manipulateData(data) {
    data['start_date'] = this.startDate
    data['end_date'] = this.endDate

    // Collect all checked status_ids
    const statusIds = [];
    this.statusFilterTargets.forEach((filter) => {
      if (filter.checked) statusIds.push(filter.value)
    });
    data['status_ids'] = statusIds;

    return data
  }

  applyStatusFilter() {
    this.dataTable.draw();
  }

  removeStatusFilter() {
    this.statusFilterTargets.forEach(cb => cb.checked = false);
    this.dataTable.draw();
  }

  get columns() {
    return [
      {data: 'ordinal', name: 'ordinal'},
      {data: 'date', name: 'date'},
      {data: 'attendees', name: 'attendees'},
      {data: 'status', name: 'status'},
      {data: 'actions', name: 'actions'}
    ]
  }

  get searching() {
    return false
  }

  get ordering() {
    return false
  }

  get lengthChange() {
    return false
  }
}
